<template>
  <div class="loading-container absolute screen-message-container deny-events">
    <img class="rider" src="../assets/images/rider.png"/>
    <div class="background"></div>
    <div class="loader-container">
      <md-progress-bar md-mode="indeterminate" class="progress-bar"></md-progress-bar>
      <div class="loader-label">{{ $t('SEARCH.LOADING') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingComponent'
}
</script>

<style lang="sass" scoped>
.screen-message-container
  position: absolute
  width: 100%
  margin-top: 50vh
  z-index: 200

  .background
    position: absolute
    z-index: 300
    width: 100%
    height: 100%
    background-color: rgba(94, 149, 237, 0.21)
    top: 0

  .rider
    position: absolute
    z-index: 500
    bottom: 15%
    left: 5.1%

  .loader-container
    position: absolute
    z-index: 400
    width: 300px
    bottom: calc(15% + 135px)
    left: 5.1%
    .loader-label
      color: #FFFFFF
      float: right
.progress-bar
  height: 7px
  border-radius: 25px
  background-color: transparent !important
</style>
